import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Usuario } from 'src/app/models/entities/usuario';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { take } from 'rxjs/operators';
import { TipoConsultaEnum } from '../shared/enums/tipo-consulta-enum.enum';
@Injectable({
  providedIn: 'root'
})
export class UsuarioEnSesionService {

  private usuario$ = new BehaviorSubject<UsuarioSesionDTO>(null);
  private tipoConsulta$ = new BehaviorSubject<'proceso' | 'planeación' | 'administración'>(null);
  constructor() {
  }

  public inicializar() {
    this.actualizarUsuario(null);
    this.actualizarTipoConsulta(null);
  }

  public actualizarUsuario(usuario: UsuarioSesionDTO) { this.usuario$.next(usuario); }
  public obtenerUsuario(): Observable<UsuarioSesionDTO> { return this.usuario$.asObservable(); }

  public actualizarTipoConsulta(tipoConsulta: 'proceso' | 'planeación' | 'administración') { this.tipoConsulta$.next(tipoConsulta); }
  public obtenerTipoConsulta(): Observable<'proceso' | 'planeación' | 'administración'> { return this.tipoConsulta$.asObservable(); }

  public async obtenerKeyTipoObra(): Promise<string> {
    let tipoConsulta = await this.obtenerTipoConsulta().pipe(take(1)).toPromise();
    if (tipoConsulta === 'proceso') {
      return TipoConsultaEnum.PROCESO;
    } else if (tipoConsulta === 'planeación') {
      return TipoConsultaEnum.PLANEACION;
    } else {
      return TipoConsultaEnum.ADMINISTRACION;
    }
  }

}
